<template>
  <multiselect
    class="ui-dropdown"
    :value="value"
    :options="options"
    :placeholder="placeholder"
    :label="label"
    :track-by="trackBy"
    :hide-selected="true"
    select-label=""
    selected-label=""
    deselect-label=""
    :allow-empty="false"
    @input="onInput"
    @close="onClose"
  >
    <template v-slot:caret="{ toggle }">
      <div class="ui-dropdown__caret caret backoffice-icons" @mousedown.prevent.stop="toggle">
        chevron_down
      </div>
    </template>
    <template slot="noResult">
      {{ $t('dropdown.noResult') }}
    </template>
    <template slot="noOptions">
      {{ $t('dropdown.noOptions') }}
    </template>
  </multiselect>
</template>

<script>
import Multiselect from 'vue-multiselect'

export default {
  name: 'UiDropdown',
  props: {
    value: {
      type: [String, Object],
      required: true,
    },
    options: {
      type: Array,
      required: true,
    },
    placeholder: {
      type: String,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    trackBy: {
      type: String,
      required: true,
    },
  },
  components: {
    Multiselect,
  },
  methods: {
    onInput(value) {
      this.$emit('input', value)
    },
    onClose() {
      this.$emit('close')
    },
  },
}
</script>

<style lang="scss" scoped>
.ui-dropdown {
  z-index: 3;
  height: $input-min-height;

  &__caret {
    position: absolute;
    top: 50%;
    right: 16px;
    transform: translateY(-50%);
    transition: transform $transition-duration-fast ease-in-out;
    color: $generic-color-text;
  }

  &.multiselect--active {
    .caret {
      transform: translateY(-50%) rotate(180deg);
    }
  }
}
</style>
